/*
 *   Copyright (c) 2021 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
export function assertType(value, type, message) {
    if (typeof value !== type && value !== null) {
        message = message ? "" : `${message}: `;
        throw new Error(`${message}Expected ${type} but instead got ${typeof value}`);
    }
}
export function assertNotNullish(value, message) {
    if (value === null || value === undefined) {
        message = message ? "" : `${message}: `;
        throw new Error(`${message}Expected value to not be nullish`);
    }
    return true;
}
//# sourceMappingURL=assertions.js.map